import { useCallback, useState } from "react";
import { applyThemeChoice, readThemeChoice, type ThemeChoice } from "@client/lib/theme";

const THEME_OPTIONS: { value: ThemeChoice; label: string }[] = [
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
  { value: "system", label: "System" },
];

/** Three explicit states, because "system" is a choice and not the absence of one. */
export function ThemeToggle() {
  const [theme, setTheme] = useState<ThemeChoice>(readThemeChoice);

  const choose = useCallback((choice: ThemeChoice) => {
    setTheme(choice);
    applyThemeChoice(choice);
  }, []);

  return (
    <div
      className="flex gap-1 rounded-lg border border-line bg-chip-bg p-1"
      role="group"
      aria-label="Colour theme"
    >
      {THEME_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => choose(option.value)}
          aria-pressed={theme === option.value}
          className={`rounded-md px-3 py-1 text-xs font-semibold transition-colors ${
            theme === option.value
              ? "bg-azure-deep text-on-accent"
              : "text-ink-soft hover:bg-link-bg-hover"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
